<script>
  import ValidatorMixin from "../mixins/validator";

  export default {
    mixins: [ValidatorMixin],

    data() {
      return {
        form: this.getForm(),
        rules: _.mapValues(this.getForm(), () => [{validator: this.fieldExternalValidator}]),
      }
    },

    methods: {
      /**
       * @return {object}
       */
      getForm() {
        return {};
      },

      /**
       * @event build
       */
      build() {
        this.$emit('input', {...this.form});
      },

      /**
       * @param {object} errors
       */
      setErrors(errors) {
        this.errors = {...errors};
        this.$refs.form.validate(() => {});
      },
    }
  }
</script>
